module.exports = __webpack_public_path__ + "static/Base-bc3c0306bf79aa9eb5ac80df92fe707b.svg";